var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["loyalty-modal-success.j2"] = require( "loyalty-modal-success.j2" );
dependencies["loyalty-success-content.j2"] = require( "loyalty-success-content.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["loyalty/templates/loyalty-success.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "loyaltyModal")) {
output += "\n    ";
env.getTemplate("loyalty-modal-success.j2", false, "loyalty/templates/loyalty-success.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n";
})});
}
else {
output += "\n    <div class=\"o-row s-loyalty-success\">\n        <div class=\"g-loyalty-form__success\">\n\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"loyaltyForm")),"landingPage")) {
output += "\n                <div class=\"dom-loyalty-success-page u-centered-content\" data-qa-loyalty-success>\n                    ";
env.getTemplate("loyalty-success-content.j2", false, "loyalty/templates/loyalty-success.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n                </div>\n            ";
})});
}
output += "\n\n        </div>\n    </div>\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["loyalty/templates/loyalty-success.j2"] , dependencies)